import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class QmsDocumentService extends Service {
	constructor(injector: Injector) {
		super("QMSDocument", injector);
	}
}